module.exports = __webpack_public_path__ + "img/lg_ring_y_s_0_0@2x.3f50dc73.png";